var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPlans16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 2L7.25 5H9.25L9.5 2H11.5L11.25 5H13.9997V7H11.0833L10.9167 9H13.9997V11H10.75L10.5 14H8.5L8.75 11H6.75L6.5 14H4.5L4.75 11H1.99973V9H4.91667L5.08333 7H1.99973V5H5.25L5.5 2H7.5ZM8.91667 9L9.08333 7H7.08333L6.91667 9H8.91667Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlans16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;